import { defineStore } from 'pinia';

import {
  AccountDetailResponse,
  AccountRepository,
  AcquirerResponse,
  CompanyResponse,
  IssuerResponse,
  ShopResponse,
  WalletServiceResponse,
} from '@/repositories/generated';
import { AccountEditForm } from '@/validations';

type TAccountState = {
  form: AccountEditForm | undefined;
  initData: AccountDetailResponse | undefined;
  selectedAcquirerName: AcquirerResponse | undefined;
  selectedIssuerName: IssuerResponse | undefined;
  selectedWalletServiceName: WalletServiceResponse | undefined;
  selectedCompanyName: CompanyResponse | undefined;
  selectedShopName: ShopResponse | undefined;
};

export const useEditAccountStore = defineStore('editAccount', {
  state: (): TAccountState => ({
    form: undefined,
    initData: undefined,
    selectedAcquirerName: undefined,
    selectedIssuerName: undefined,
    selectedWalletServiceName: undefined,
    selectedCompanyName: undefined,
    selectedShopName: undefined,
  }),
  actions: {
    async editAccount() {
      const { form } = this;

      if (!form || !this.initData) return;

      await AccountRepository.edit({
        id: this.initData.id ?? '',
        requestBody: {
          email: form.email,
          loginId: form.loginId,
          name: form.name,
          remarks: form.remarks,
          lastUpdatedAt: this.initData.updatedAt ?? '',
        },
      });
    },
    setForm(form: AccountEditForm) {
      const createFrom = (_form: AccountEditForm) => ({
        ..._form,
      });
      this.form = createFrom(form);
    },
    async setInitData(id: string) {
      this.$reset();

      const response = await AccountRepository.detail({ id });
      this.initData = response;
    },
    setUiForm(form: AccountEditForm) {
      const createForm = (_form: AccountEditForm) => ({
        ..._form,
      });
      this.form = createForm(form);
    },
    $resetForm() {
      this.form = undefined;
    },
  },
});
